import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import lastAssessmentDateReducer from "./slices/lastAssessmentDate";
import patientProfileReloadReducer from "./slices/patientProfileReload";
import clinicalAlertReloadReducer from "./slices/clinicalAlertReload";
import pageTitleReducer from "./slices/pageTitleSlice";
import filterReducer from "./slices/filterSlice";
import toastReducer from "./slices/toastSlice";
import appointmentOverlayReducer from "./slices/appointmentOverlaySlice";
import patientRpmOnlyReducer from "./slices/patientRpmOnly";
import {
  appointmentOverlayPersistence,
  loadOverlayState,
  subscribeToOverlayChanges,
} from "./appointmentOverlayStorage";
import { overlayStateSynced } from "./slices/appointmentOverlaySlice";

const persistedOverlayState = loadOverlayState();

export const store = configureStore({
  reducer: {
    user: userReducer,
    pageTitle: pageTitleReducer,
    lastAssessmentDate : lastAssessmentDateReducer,
    patientProfileReloadKey : patientProfileReloadReducer,
    clinicalAlertReloadKey : clinicalAlertReloadReducer,
    pageFilter : filterReducer,
    toast: toastReducer,
    appointmentOverlay: appointmentOverlayReducer,
    patientRpmOnly: patientRpmOnlyReducer,
  },
  // Rehydrates the appointment overlay after a refresh (WCP-13240).
  preloadedState: persistedOverlayState
    ? { appointmentOverlay: persistedOverlayState }
    : undefined,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(appointmentOverlayPersistence),
});

// Keeps the appointment overlay the same in every tab.
subscribeToOverlayChanges((state) => store.dispatch(overlayStateSynced(state ?? null)));

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
